import { render, staticRenderFns } from "./ApplicationIntro.vue?vue&type=template&id=524fe0cb&scoped=true&"
import script from "./ApplicationIntro.vue?vue&type=script&lang=js&"
export * from "./ApplicationIntro.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationIntro.vue?vue&type=style&index=0&id=524fe0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524fe0cb",
  null
  
)

export default component.exports